import { render, staticRenderFns } from "./MinhaRespostaProdutosTable.vue?vue&type=template&id=8528372a&scoped=true"
import script from "./MinhaRespostaProdutosTable.vue?vue&type=script&lang=js"
export * from "./MinhaRespostaProdutosTable.vue?vue&type=script&lang=js"
import style0 from "./MinhaRespostaProdutosTable.vue?vue&type=style&index=0&id=8528372a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8528372a",
  null
  
)

export default component.exports